// src/app/core/api-base-url.token.ts
import { InjectionToken } from '@angular/core';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  providedIn: 'root',
  factory: () => {
    const host = window.location.host;
    if (host.includes('app-dev.waitora.com')) return 'https://app-dev.waitora.com';
    if (host.includes('app.waitora.com'))    return 'https://app.waitora.com';
    return 'http://localhost:8080'; // local
  }
});
